import { cloneDeep } from 'lodash';

import { CustomLink } from '../../../../components/CustomLink';
import { useThisWeekVegetables } from '../../../../utils/hook/recipe';
import { useRouterQuery } from '../../../../utils/hook/useRouterQuery';

import { useDiaryShortsContext } from './_DiaryShortsRoot';

const _DiaryShortsIngredients = () => {
  const {
    diary: { ingredients },
  } = useDiaryShortsContext();
  const { sortedByMarkedVeges } = useThisWeekVegetables(ingredients);
  const { stringify } = useRouterQuery();
  const MAXIMUM_SHOW = 3;

  return (
    <ul className="flex flex-wrap items-center gap-6px">
      {cloneDeep(sortedByMarkedVeges)
        .splice(0, MAXIMUM_SHOW)
        .map(({ name, marked }) => (
          <CustomLink
            key={name}
            href={`/recipes/search?${stringify({ q: name, tab: 'diary' })}`}
            className={`flex-shrink-0 cursor-pointer rounded-[10px] p-6px text-14px font-medium ${
              marked
                ? 'bg-gray-200 text-gray-800'
                : 'border border-white text-white'
            }`}
            style={{ lineHeight: '14px' }}
          >
            {name}
          </CustomLink>
        ))}
      {sortedByMarkedVeges.length > MAXIMUM_SHOW && (
        <p className="text-14px font-medium text-white">
          +{sortedByMarkedVeges.length - MAXIMUM_SHOW}
        </p>
      )}
    </ul>
  );
};

export default _DiaryShortsIngredients;
